import React from 'react';
import PropTypes from 'prop-types';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

const Result = ({ title, date, url, isExternal, ctaLabel }) => {
  const link = {
    href: url
  };

  if (isExternal) {
    link.target = '_blank';
    link.rel = 'noreferrer';
  }

  return (
    <a {...link} className="news-card news-card--external">
      <div className="news-card__inner">
        <div className="news-card__title">
          <ResponsiveEllipsis
            text={title}
            maxLine="1"
            basedOn="letters"
            component="p"
          />
          {isExternal && (
            <svg viewBox="0 0 320 320" className="news-card__external">
              <use xlinkHref="#external-link" />
            </svg>
          )}
        </div>
        <p className="news-card__date">{date}</p>
        <span className="link">{ctaLabel}</span>
      </div>
    </a>
  );
};

Result.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isExternal: PropTypes.bool,
  ctaLabel: PropTypes.string.isRequired
};

export default React.memo(Result);
